import React from 'react'
import "../CSS/Education.css"

const Education = () => {
  return (
    <div className='EducationWrap'>
        <div className='Education'>
        <h1 >EDUCATION</h1>
        <h2>Enugu State University of Science 
        and Technology</h2>
        <h3>Civil Engineering – B.Eng. 2008</h3>
    </div>
    </div>
  )
}

export default Education
